import { on, createReducer, Action } from '@ngrx/store';
import { MenuBaseActions } from './menu-base.actions';

export const baseFeatureKey = 'base';

export interface MenuBaseState {
    effectiveDate: string;
    initialized: boolean;
    sidenavOpened: boolean;
}

const today = new Date().toISOString();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
const effectiveDate = tomorrow.toISOString();

const initialState: MenuBaseState = {
    effectiveDate,
    initialized: false,
    sidenavOpened: true
};

const menuBaseCreateReducer = createReducer(
    initialState,
    on(MenuBaseActions.changeEffectiveDate, (state: MenuBaseState, { effectiveDate }) => ({
        ...state,
        effectiveDate
    })),
    on(MenuBaseActions.init, (state) => ({
        ...state,
        initialized: true
    }))
);

export function menuBaseReducer(state: MenuBaseState | undefined, action: Action) {
    return menuBaseCreateReducer(state, action);
}
